import {Edge} from '../model'

// Action about paperEdges data

export interface InitPaperEdgesAction {
    type: "INIT_PAPER_EDGES";
    initialState: Array<Edge>;
}

export const initPaperEdges = (initialState: Array<Edge>): InitPaperEdgesAction => ({
    type: "INIT_PAPER_EDGES",
    initialState,
});

export type PaperEdgesAction = InitPaperEdgesAction;